import Vue from 'vue'
import App from '@/App.vue'

import router from '@/boot/router.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars, faAngleLeft, faAngleRight, faHome, faDotCircle, faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import '@ds/sass/core.scss';

library.add(faBars, faAngleLeft, faAngleRight, faHome, faDotCircle, faStopCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
new Vue({
	render: h => h(App),
	router
}).$mount('#app');